// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__aKy8l","actionsCol":"EnrolledClinics_actionsCol__1g5yv"};